import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
.textColorMain {
    color: ${(props) => props.theme.mainColor} !important;
}
`;

export default GlobalStyle;
